export { AppLayoutComponent } from './lib/app-layout.component';
export { MAIN_MENU_CONFIG_TOKEN } from './lib/main-menu-config.token';
export { TOP_RIGHT_MENU_CONFIG_TOKEN } from './lib/top-right-menu-config.token';
export { type MenuItem, type MainMenuItem, type MainMenuConfig } from './lib/main-menu-config.type';
export { DESKTOP_BP } from './lib/desktop-breakpoint';
